export default __webpack_public_path__ + "static/media/home_accademia.21fb6c83.jpg";